import React, { useMemo } from 'react';
import clsx from 'clsx';
import OrderListItemProps from '../../../Types/OrderListItemProps';
import { translate } from '../../../Services/translation';

const OrderListItemDesktop = ({
  order,
  onClick,
  isB2b,
}: OrderListItemProps) => {
  const deliveryWithTracking = useMemo(
    () => order.deliveries.find((d) => !!d.trackingUrl),
    [order.deliveries]
  );
  const trackingUrl = deliveryWithTracking?.trackingUrl;
  let trackingIdFromUrl = null;
  if (trackingUrl) {
    const segments = trackingUrl.split('/');
    const lastPart = segments[segments.length - 1];
    if (trackingUrl !== lastPart) {
      trackingIdFromUrl = lastPart;
    }
  }
  const trackingReference =
    deliveryWithTracking?.trackingReference ?? trackingIdFromUrl;

  return (
    <li
      className={clsx(
        'grid gap-4 border-b border-solid border-gray-200 px-2 py-5 [&:last-child]:border-b-0 [&:nth-child(even)]:bg-gray-50',
        isB2b ? 'grid-cols-6' : 'grid-cols-5'
      )}
    >
      <a
        className="cursor-pointer text-base underline"
        onClick={() => onClick && onClick(order)}
      >
        {order.externalOrderID}
      </a>
      <span className="text-base">{order.orderDate}</span>
      <span className="text-base">{order.orderGrandTotal}</span>
      {isB2b && (
        <span className="text-base">
          {order?.alternateOrderNumber ?? ''}
        </span>
      )}
      <span className="text-base">
        {translate(`order-status.${order.orderStatus.toLowerCase()}`)}
      </span>
      <span className="text-base">
        {trackingUrl ? (
          <a
            className={clsx(
              'underline',
              !!trackingReference && 'uppercase'
            )}
            target="_blank"
            href={trackingUrl}
            aria-label="Tracking URL"
            rel="noreferrer"
          >
            {trackingReference ?? trackingUrl}
          </a>
        ) : (
          <p>{translate('mypage.order.no-tracking')}</p>
        )}
      </span>
    </li>
  );
};

export default OrderListItemDesktop;
